import React from "react"
import { Button } from "@mui/material"
import { store } from "../../../../../stores/Store"
import { AlertModal, DisplayValue } from "../../../../.."
import { Icons } from "../../../../../misc/Icons"


export default function AutomationStatus ({automator}) {

    const { statusColor, statusDescription, cancel } = store.AutomationStore
    const [cancelling, setCancelling] = React.useState(false)

    var color = statusColor(automator.status)
    var description = statusDescription(automator)
    var status = DisplayValue("automation_status", automator.status)

    const onCancel = async () => {
        setCancelling(true)
        await cancel(automator.id)
    }

    return (
        <div style={{color: color}}>
            <div style={{display: "flex", alignItems: "center", columnGap: "10px"}}>
                <span>
                    <b>
                        {automator.status === "RUNNING" && cancelling ? "Cancelling..." : `${status},`} {Math.floor(((automator.current_page + 1) / automator.total_pages) * 100)}% complete
                    </b>
                </span>
                
                {["RUNNING", "INSTANTIATED"].includes(automator.status) ? (
                    <Button 
                        onClick={() => onCancel()} 
                        className="btn btn-xs" 
                        color="error" 
                        disabled={cancelling}
                        variant="contained">
                        Cancel
                    </Button>
                ) : null}
            </div>
            
            <div style={{marginLeft: "8px"}}>
                <small>{description}</small>

                {automator?.validation_messages?.length ? (
                    <div>
                        {automator?.validation_messages.map((message, i) => (
                            <small key={i} className="warning" style={{margin: "10px", display: "list-item"}}>{message}</small>
                        ))}
                    </div>
                ) : null}

                {automator.error_page_src ? (
                    <Button 
                        color="error"
                        variant="contained"
                        className="btn btn-xs" 
                        onClick={() => {
                            AlertModal({title: status + " - Preview", body: <HtmlPreview automator={automator} />, width: "1000px"})
                        }}>
                        <Icons.Open /> Open error preview
                    </Button>
                ) : null}
            </div>
        </div>
    )
}

function HtmlPreview ({automator}) {

    const ref = React.useRef<HTMLIFrameElement>()

    // Replace relative paths with absolute paths
    var webAddress = ""
    if (automator.navigation_style === "home_office_classic") {
        webAddress = "https://visas-immigration.service.gov.uk"
    } else if (automator.navigation_style === "home_office_dashboard") {
        webAddress = "https://apply-to-visit-or-stay-in-the-uk.homeoffice.gov.uk"
    } else if (automator.navigation_style === "cos_sms") {
        webAddress = "https://www.points.homeoffice.gov.uk"
    }
    automator.error_page_src = automator.error_page_src.replaceAll('href="/', `href="${webAddress}/`).replaceAll('src="/', `src="${webAddress}/`)    

    React.useEffect(() => {
        if (ref.current) {
            ref.current.contentWindow.document.write(`<div style="pointer-events: none">${automator.error_page_src}</div>`)
        }
    })

    return (
        <div>
            <iframe style={{minWidth: "300px", width: "100%", height: "400px"}} ref={ref} />
        </div>
    )
}